import types from '../../mutation-types';
import PaymentAPI from '../../../api/payments';

export const actions = {
  get: async ({ commit }, { page = 1, sortAttr = '-created_at', clientId = null, dateFrom = null, dateTo = null, requestStatus = null, paymentStatus = null } = {}) => {
    commit(types.SET_PAYMENT_UI_FLAG, { isFetching: true });
    try {
      const filters = {
        dateFrom,
        dateTo,
        requestStatus,
        paymentStatus,
      };
      const {
        data: { payload, meta },
      } = await PaymentAPI.get(page, sortAttr, clientId, filters);
      commit(types.CLEAR_PAYMENTS);
      commit(types.SET_PAYMENTS, payload);
      commit(types.SET_PAYMENT_META, meta);
      commit(types.SET_PAYMENT_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_PAYMENT_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  show: async ({ commit }, id) => {
    commit(types.SET_PAYMENT_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await PaymentAPI.show(id);
      commit(types.SET_PAYMENT_UI_FLAG, { isFetchingItem: false });
      return data.payload;
    } catch (error) {
      commit(types.SET_PAYMENT_UI_FLAG, { isFetchingItem: false });
      throw error;
    }
  },

  create: async ({ commit }, data) => {
    commit(types.SET_PAYMENT_UI_FLAG, { isCreating: true });
    try {
      const { data: response } = await PaymentAPI.create(data);
      commit(types.ADD_PAYMENT, response.payload);
      commit(types.SET_PAYMENT_UI_FLAG, { isCreating: false });
      return response.payload;
    } catch (error) {
      commit(types.SET_PAYMENT_UI_FLAG, { isCreating: false });
      throw error;
    }
  },

  update: async ({ commit }, { id, ...updateData }) => {
    commit(types.SET_PAYMENT_UI_FLAG, { isUpdating: true });
    try {
      const { data: response } = await PaymentAPI.update(id, updateData);
      commit(types.EDIT_PAYMENT, response.payload);
      commit(types.SET_PAYMENT_UI_FLAG, { isUpdating: false });
      return response.payload;
    } catch (error) {
      commit(types.SET_PAYMENT_UI_FLAG, { isUpdating: false });
      throw error;
    }
  },
};
